module.exports = __webpack_public_path__ + "img/抓狂.8e559e5f.png";